import SideNav from './SideNav';

export { default as Toggle } from './Toggle';
export { default as Nav } from './Nav';
export { default as NavItem } from './NavItem';
export { default as NavIcon } from './NavIcon';
export { default as NavText } from './NavText';

module.exports = SideNav;



// WEBPACK FOOTER //
// ./src/index.js